





import BaseAddress from '@shared/components/@atoms/BaseAddress/BaseAddress.vue';
import Vue from 'vue';

Vue.component('BaseAddress', BaseAddress);
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BaseAddressPicker',
  provide() {
    return {
      getSelectedValue: this.getSelectedValue,
      setSelectedValue: this.setSelectedValue,
    };
  },
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    selected: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedValue: this.selected,
    };
  },
  watch: {
    selected(newVal) {
      this.selectedValue = newVal;
    },
  },
  methods: {
    getSelectedValue() {
      return this.selectedValue;
    },
    // @ts-ignore migrated from ui-library
    setSelectedValue(newVal) {
      const newValue = newVal;
      this.selectedValue = newValue;
      this.$emit('change', newValue);
    },
  },
});
